module.exports = __webpack_public_path__ + "img/flotte_quote.8d161307.png";